import { inject, Pipe, PipeTransform } from '@angular/core';
import { Observable } from 'rxjs';

import { PermissionCheckOptions } from '../auth.model';
import { AuthorizationService } from '../authorization.service';

// Todo: Remove this from here, the core folder should not contain components, directives or pipes

/**
 * This pipe checks if the user has all or any of the given permissions (depending on the mode).
 * Please note that the return type is an Observable, so this pipe needs to get used
 * together with the async pipe.
 *
 * @example
 * The user needs any of the given permissions:
 * <div *ngIf="['PERM_A', 'PERM_B'] | userHasPermissions : 'any' | async">authorized content</div>
 *
 * The user needs all of the given permissions:
 * <div *ngIf="['PERM_A', 'PERM_B'] | userHasPermissions : 'all' | async">authorized content</div>
 */
@Pipe({
  name: 'userHasPermissions',
  standalone: true,
  pure: true,
})
export class UserHasPermissionsPipe implements PipeTransform {
  authorizationService = inject(AuthorizationService);

  transform(
    permissions: string | string[],
    mode: 'any' | 'all',
    options?: PermissionCheckOptions,
  ): Observable<boolean> {
    if (mode === 'any') {
      return this.authorizationService.userHasAnyPermission(permissions, options);
    }
    return this.authorizationService.userHasAllPermissions(permissions, options);
  }
}
